import { Employee } from '../employees/employees.model';

export enum ExpenseStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum ExpenseCategory {
  TRAVEL = 'travel',
  FOOD = 'food',
  MATERIALS = 'materials',
  OTHER = 'other',
}

export type ExpenseSummary = {
  total_amount: number;
  request_count: number;
};

export type ExpenseSummaryResponse = Record<ExpenseStatus, ExpenseSummary>;

export type Expense = {
  id: string;
  employee: Employee;
  created_at: string;
  updated_at: string;
  date_of_expense: string;
  category: string;
  amount: string;
  description: string;
  receipt: string | null;
  status: ExpenseStatus;
};

export type UpdateExpenseStatusResponse = {
  status: ExpenseStatus;
};
